import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useAppDispatch } from 'store/store';
import { getDeniedAccessError } from 'store/user-service/selector';
import { setDeniedAccessErrorOpen } from 'store/user-service/userSlice';

import { NamespacesList } from 'core/enums/common';

import { InfoModal } from 'components/shared/Modal/Info';

import { ReactComponent as Error } from 'assets/icons/error.svg';

export const DeniedAccessModal = () => {
	const { t: modalTranslate } = useTranslation(NamespacesList['modals']);

	const dispatch = useAppDispatch();

	const isOpen = useSelector(getDeniedAccessError);

	const handleClose = () => {
		dispatch(setDeniedAccessErrorOpen(false));
	};

	return (
		<InfoModal
			isOpen={isOpen || false}
			onClose={handleClose}
			image={<Error />}
			title={modalTranslate('accessDeniedModal.title')}
			description={modalTranslate('accessDeniedModal.description')}
			buttons={
				<Button
					className="not-rtl-able"
					onClick={handleClose}
					sx={{
						height: '44px',
						width: { xs: '90%', sm: '100%' },
						borderRadius: '8px',
						textTransform: 'none',
						fontSize: '16px',
						fontWeight: '700',
						marginTop: '24px',
						border: '1px solid rgb(251, 11, 36)',
						color: 'rgb(251, 11, 36)',
						'&:hover': {
							border: '1px solid rgb(254, 74, 82)',
							background: 'rgb(254, 230, 232)',
							color: 'rgb(254, 74, 82)',
						},
					}}
				>
					{modalTranslate('accessDeniedModal.confirm')}
				</Button>
			}
		></InfoModal>
	);
};
